import { render, staticRenderFns } from "./AddWordRevenueReportFields.vue?vue&type=template&id=c1eeb536&scoped=true"
import script from "./AddWordRevenueReportFields.vue?vue&type=script&lang=js"
export * from "./AddWordRevenueReportFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1eeb536",
  null
  
)

export default component.exports